module.exports = __webpack_public_path__ + "static/media/Nunito-Bold.1cd294a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-Bold.ttf
// module id = 302
// module chunks = 0